import {useLocation, useNavigate} from "react-router-dom";
import React, {useEffect, useState} from "react";
import AdminHeader from "../../Components/AdminHeader/AdminHeader";
import AdminNav from "../../Components/AdminNav/AdminNav";
import {deleteVacancy, getVacancies} from "../../actions/Vacancies";
import {IMAGE_URL} from "../../path";
import './Vacancies.css'

function VacanciesList() {
    const location = useLocation();
    const user = location.state?.user;
    const [isCollapsed, setIsCollapsed] = useState(true);
    const navigate = useNavigate();

    if (!location || !location.state || !user) {
        navigate('/login');
    }

    const [vacancies, setVacancies] = useState<any[]>([]);

    const handleDelete = async (postId: number) => {
        if (window.confirm("Are you sure you want to delete this vacancy?")) {
            try {
                await deleteVacancy(postId);
                fetchVacancies();
            } catch (error) {
                console.error("Failed to delete vacancy:", error);
                alert("Failed to delete the vacancy. Please try again.");
            }
        }
    };

    const fetchVacancies = () => {
        getVacancies()
            .then(response => {
                setVacancies(response.data);
            })
            .catch(error => {
                console.error("Failed to fetch vacancies:", error);
            });
    };

    useEffect(() => {
        fetchVacancies();
    }, []);

    return (
        <div>
            <AdminHeader isCollapsed={isCollapsed} setIsCollapsed={setIsCollapsed} user={user} />
            <AdminNav collapsed={isCollapsed} setCollapsed={setIsCollapsed} user={user} />

            <div className={`main-admin-page ${isCollapsed ? "collapsed" : "expanded"}`}>
                {/* Single Add Vacancy Button */}
                <div className="content-form-button right-align">
                    <button
                        type="button"
                        className="button button-right"
                        onClick={() => navigate('/dashboard/vacancies/create', { state: { user } })}
                    >
                        Add Vacancy
                    </button>
                </div>

                <div className="table-container">
                    <table className="news-table">
                        <thead>
                        <tr>
                            <th style={{ width: "50%" }}>Title</th>
                            <th style={{ width: "10%" }}>Date</th>
                            <th style={{ width: "20%" }}>Image</th>
                            <th style={{ width: "20%" }}>Actions</th>
                        </tr>
                        </thead>
                        <tbody>
                        {vacancies.map((post) => (
                            <tr key={post.id}>
                                <td>{post.title}</td>
                                <td>{post.year_posted}</td>
                                <td>
                                    {post.image_path ? (
                                        <img
                                            src={IMAGE_URL + post.image_path}
                                            alt="Cover"
                                            style={{
                                                width: "100%",
                                                maxHeight: "120px",
                                                objectFit: "cover",
                                                borderRadius: "4px",
                                            }}
                                        />
                                    ) : (
                                        <span>No image</span>
                                    )}
                                </td>
                                <td>
                                    <button
                                        className="button small"
                                        onClick={() =>
                                            navigate(`/dashboard/vacancies/${post.id}/edit`, {
                                                state: { user },
                                            })
                                        }
                                        style={{ marginRight: "10px" }}
                                    >
                                        View / Edit
                                    </button>
                                    <button
                                        className="button small danger"
                                        onClick={() => handleDelete(post.id)}
                                        style={{ color: "black" }}
                                    >
                                        Delete
                                    </button>
                                </td>
                            </tr>
                        ))}
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    );
}

export default VacanciesList;
